module.exports = __webpack_public_path__ + "assets/img/29_302.502005d9.jpg";